// @flow
import { createAction } from 'redux-actions';
import types from './types';

export const toggleBackbone = createAction(types.TOGGLE_BACKBONE);

export default {
    toggleBackbone,
};
